module.exports = __webpack_public_path__ + "static/googlelogo-9b224c9884c2bb081d4ac92b23675c2e.png";